<template>
  <div>
    <b-col
        md="12"
        xl="12"
        class="mb-1"

    >
      <b-card-code title="Passwort">
        <b-row>

          <b-col
              md="4"
              xl="4"
          >
            <b-form-group label="Jetziges Passwort">
              <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
              >
                <b-form-input
                    v-model="password1"
                    :state="errors.length > 0 ? false:null"
                    class="form-control-merge"
                    :type="passwordFieldType"
                    placeholder="············"
                />
                <b-input-group-append is-text>
                  <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon()"
                      @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
          >
            <b-form-group label="Neues Passwort">
              <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
              >
                <b-form-input
                    v-model="password2"
                    :state="errors.length > 0 ? false:null"
                    class="form-control-merge"
                    :type="passwordFieldType"
                    placeholder="············"
                />
                <b-input-group-append is-text>
                  <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon()"
                      @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
          >
            <b-form-group label="Neues Passwort wiederholen">
              <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
              >
                <b-form-input
                    v-model="password3"
                    :type="passwordFieldType"
                    :class="errors.length > 0 ? 'is-invalid':null"
                    placeholder="············"
                />
                <b-input-group-append is-text>
                  <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon()"
                      @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

          </b-col>
        </b-row>
        <b-row>
          <b-col
              md="12"
              xl="12"
              class="float-right"
          >
            <b-col
                md="5"
                xl="5"
                class="mt-2"
            >
              <div>
                <span class="mt-4 text-danger" v-show="errors.length > 0">{{ errors[0] }}</span>
              </div>
            </b-col>
            <b-col
                md="6"
                xl="6"
                class="float-right"
            >
              <b-button
                  class="col-5 float-right"
                  variant="warning"
                  size="sm"
                  @click="ChangePassword()"
              >
                <feather-icon
                    icon="LockIcon"
                    size="22"
                />
                <span> Passwort ändern </span>
              </b-button>
            </b-col>
          </b-col>
        </b-row>
      </b-card-code>
    </b-col>
  </div>

</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BDropdown, BDropdownItem
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import BCardCode from '@core/components/b-card-code'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { password } from '@core/utils/validations/validations'

export default {
  name: 'Account',
  components: {
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardCode,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      password1: '',
      password2: '',
      password3: '',
      passwordFieldType: 'password',
      errors: []
    }
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      document.title = 'Flughafenservice Rech - Account'
    })
  },
  methods: {
    Reset() {
      this.password1 = ""
      this.password2 = ""
      this.password3 = ""
    },
    togglePasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'

    },
    ChangePassword() {
      this.errors = []
      if(this.password1.length == 0) {
        this.errors.push("Aktuelles Password eingeben.")

      }
      if(this.password2.length < 8) {
        this.errors.push("Neues Passwort ist zu Kurz.")

      }
      if (this.password2 != this.password3) {
        this.errors.push('Neues Passwort stimmt nihct mit der wiederholung überein.')
      }
      if (this.errors.length == 0) {
        this.$http.post('/api/user/password/change', JSON.stringify({
          'passwordOld': this.password1,
          'passwordNew': this.password2,
          'passwordNew2': this.password3
        }))
            .then(resp => {
              if (resp.data.success) {
                this.Reset();
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Passwort',
                    icon: 'CheckIcon',
                    text: 'Passwort wurde geändert.',
                    variant: 'success',
                  },
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Fehler',
                    icon: 'CheckIcon',
                    text: resp.data.message == 'password failed' ? 'Aktuelles Password ist falsch' : 'Es ist ein Fehler aufgetreten.',
                    variant: 'danger',
                  },
                })
              }
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: err,
                  variant: 'danger',
                },
              })
            })
      }
    },
    passwordToggleIcon() {
      return this.passwordFieldType == 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
}
</script>
